function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#009fe3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Interface-Essential_Select_cursor-select-circle",
  transform: "translate(-494.742 -6650.879)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_651",
  transform: "translate(495.805 6651.88)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cursor-select-circle"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape_2802",
  d: "M521.66 6667.711a52.652 52.652 0 0 1-5.551 9.56",
  className: "cls-1",
  transform: "translate(-420.589 -6593.238)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2803",
  d: "M520.123 6673.227a34.2 34.2 0 0 1-5.1 2.161 35.309 35.309 0 0 1-5.293 1.619",
  className: "cls-1",
  transform: "translate(-444.201 -6572.785)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2804",
  d: "M512.477 6677.006a34.984 34.984 0 0 1-5.293-1.619 34.205 34.205 0 0 1-5.095-2.161",
  className: "cls-1",
  transform: "translate(-472.526 -6572.785)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2805",
  d: "M502.291 6677.274a52.279 52.279 0 0 1-5.547-9.563",
  className: "cls-1",
  transform: "translate(-492.327 -6593.238)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2806",
  d: "M495.8 6670.924a52.128 52.128 0 0 1 1.882-10.892",
  className: "cls-1",
  transform: "translate(-495.805 -6621.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2807",
  d: "M498.929 6660.953a58.071 58.071 0 0 1 8.468-7.14",
  className: "cls-1",
  transform: "translate(-484.232 -6644.732)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2808",
  d: "M505.84 6652.172l5.533-.293 5.532.293",
  className: "cls-1",
  transform: "translate(-458.63 -6651.879)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2809",
  d: "M513.3 6653.813a58.56 58.56 0 0 1 8.468 7.14",
  className: "cls-1",
  transform: "translate(-430.976 -6644.732)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_2810",
  d: "M517.824 6660.032a52.13 52.13 0 0 1 1.882 10.892",
  className: "cls-1",
  transform: "translate(-414.236 -6621.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Oval_318",
  d: "M520.908 6694.663a17.642 17.642 0 1 0-17.642-17.642 17.642 17.642 0 0 0 17.642 17.642z",
  className: "cls-1",
  transform: "translate(-468.166 -6624.095)"
}))));

function SvgSelectCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.596,
    height: 106.415,
    viewBox: "0 0 107.596 106.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCircle);
export default __webpack_public_path__ + "static/media/select-circle.b1c2d703.svg";
export { ForwardRef as ReactComponent };